import {
  Box,
  Flex,
  Heading,
  Container,
  HStack,
  useDisclosure,
  Button
} from '@chakra-ui/react'
import { FC, useEffect } from 'react'

import useFilters from '@hook/shared/use-filters'

import Layout from '@component/Layout'
import UsersModal from '@component/Modules/Users/Modal'
import UsersSearcher from '@component/Modules/Users/Searcher'
import UsersTable from '@component/Modules/Users/Table'

const Users: FC = () => {
  const { getFilters, getUsers } = useFilters()
  const { isOpen, onOpen, onClose } = useDisclosure()

  useEffect(() => {
    getUsers()
    getFilters({
      profiles: true,
      categoryManagersConfig: true,
      productManagersConfig: true,
      companiesConfig: true,
      centersConfig: true,
      worldsConfig: true,
      // compactCategories: true,
      compactCategoriesConfig: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Usuários" withBackdroundDrop>
      <Container maxW="container.lg" py={6}>
        <Box bg="white" p={6} borderRadius={8} boxShadow="sm">
          <Flex alignItems="center" justifyContent="space-between" mb={4}>
            <Heading size="lg">Usuários</Heading>
            <UsersSearcher />
            <HStack spacing={2}>
              <Button size="sm" colorScheme="green" onClick={onOpen}>
                Novo usuário
              </Button>
            </HStack>
          </Flex>

          <UsersTable />
        </Box>
      </Container>

      <UsersModal isOpen={isOpen} onClose={onClose} onUpdate={getUsers} />
    </Layout>
  )
}

export default Users
